/* GIỚI THIỆU BẠN BÈ — PHÍA NGƯỜI ĐƯỢC GIỚI THIỆU (B) — eGURU 17/09/2026, phương án C anh Thắng chốt 10:19.
 *
 * VÌ SAO CÓ TỆP NÀY: Shopify không biết ai giới thiệu ai — chỉ BLOY biết, mà trigger Flow của BLOY
 * không bắn (đo 16/09) và BLOY chưa trả lời. Nên theme tự nối: link chia sẻ trong widget (custom-bloy.js)
 * gắn thêm `&gt=<id khách A>`; tệp này chạy MỌI trang phía B:
 *   1. Có `?gt=` → lưu {id, ts} vào localStorage.gt_ref. 18/09 09:30 anh Thắng chốt: LINK MỚI NHẤT THẮNG (bấm link
 *      của ai thì ghi người đó — khớp hộp BLOY đang hiện) và HẾT HẠN sau 90 ngày (trước là đầu thắng, không hết hạn).
 *   2. Khi giỏ có hàng / giỏ đổi / bấm thanh toán → ghi thuộc tính đơn `gioi_thieu_boi = <id A>`
 *      (POST /cart/update.js + input ẩn trong form giỏ). Flow đọc order.customAttributes.gioi_thieu_boi
 *      để +1 lượt cho A (website-theme dựng Flow, hợp đồng dữ liệu 17/09 10:24).
 *   3. B tự mời mình (gt == id khách đang đăng nhập) → không ghi.
 * GIỚI HẠN đã báo: nút "Mua ngay" (dynamic checkout) bỏ qua giỏ nên không mang thuộc tính; lời mời BLOY
 * gửi qua email không có gt (widget đã ẩn nút đó). Không dùng metafield ở phía này.
 */
(function () {
  'use strict';
  var KHOA = 'gt_ref';
  var THUOC_TINH = 'gioi_thieu_boi';
  var HAN_MS = 90 * 86400000;                          // 18/09: lời mời sống 90 ngày rồi tự quên

  function docLuu() {
    try {
      var s = localStorage.getItem(KHOA);
      var o = s ? JSON.parse(s) : null;
      if (o && o.ts && Date.now() - o.ts > HAN_MS) { localStorage.removeItem(KHOA); return null; }
      return o;
    } catch (e) { return null; }
  }

  // 0. (18/09 13:20, trang landing) Khách lạ bấm "Đăng nhập để lấy link giới thiệu" ở khối gioi-thieu-ban-be → khối ghi
  //    localStorage.gt_ve_lai = đường dẫn trang đó. Tài khoản mới của Shopify bỏ return_url và đưa về trang tài khoản trên
  //    shopify.com (không chạy theme), khách bấm về cửa hàng mới tới đây → đã đăng nhập + còn ghi nhớ (≤30') → đưa lại
  //    trang giới thiệu MỘT lần. Đọc ở đây vì tệp này chạy mọi trang; khối chỉ nằm ở trang có section.
  (function veLaiSauDangNhap() {
    var minh = window.eguruKhach && window.eguruKhach.id;
    var o = null;
    try { o = JSON.parse(localStorage.getItem('gt_ve_lai') || 'null'); } catch (e) {}
    if (!o || !o.duong) return;
    if (!minh) { if (Date.now() - (o.ts || 0) > 1800000) { try { localStorage.removeItem('gt_ve_lai'); } catch (e) {} } return; }
    try { localStorage.removeItem('gt_ve_lai'); } catch (e) {}
    if (Date.now() - (o.ts || 0) > 1800000) return;
    if (o.duong.charAt(0) !== '/' || o.duong.charAt(1) === '/' || o.duong.charCodeAt(1) === 92) return;   // chỉ đường dẫn nội bộ (92 = dấu \)
    if (o.duong.split('#')[0] === location.pathname + location.search) return;
    location.replace(o.duong);
  })();

  // 0b. (05/10) Khách đang đăng nhập bấm "Đăng xuất để dùng email khác" trong hộp BLOY (custom-bloy.js dangNhapHopB) →
  //     Shopify đăng xuất xong đưa về trang chủ → mở lại đúng link mời MỘT lần để hộp hiện lại cho nhập email mới.
  (function veLaiSauDangXuat() {
    var o = null;
    try { o = JSON.parse(sessionStorage.getItem('gt_mo_lai') || 'null'); } catch (e) {}
    if (!o || !o.duong) return;
    if (window.eguruKhach && window.eguruKhach.id) return;   // chưa xong đăng xuất — đợi trang sau
    try { sessionStorage.removeItem('gt_mo_lai'); } catch (e) {}
    if (Date.now() - (o.ts || 0) > 600000) return;
    if (o.duong.charAt(0) !== '/' || o.duong.charAt(1) === '/' || o.duong.charCodeAt(1) === 92) return;
    if (o.duong === location.pathname + location.search) return;
    location.replace(o.duong);
  })();

  // 1. Nhận ?gt= từ link giới thiệu
  (function nhanGt() {
    var m = location.search.match(/[?&]gt=(\d{5,20})(?:&|$)/);
    if (!m) return;
    var id = m[1];
    var minh = window.eguruKhach && window.eguruKhach.id ? String(window.eguruKhach.id) : '';
    if (minh && minh === id) return;                  // tự mời mình
    // 18/09 09:30: link mới nhất thắng — ghi đè, và làm mới ts (gia hạn 90 ngày) kể cả cùng A
    try { localStorage.setItem(KHOA, JSON.stringify({ id: id, ts: Date.now() })); } catch (e) {}
  })();

  var luu = docLuu();
  if (!luu || !luu.id) return;
  var minh2 = window.eguruKhach && window.eguruKhach.id ? String(window.eguruKhach.id) : '';
  if (minh2 && minh2 === luu.id) return;

  // 2a. Input ẩn trong mọi form giỏ (POST /cart khi bấm Thanh toán mang attributes[])
  function gaiForm() {
    var forms = document.querySelectorAll('form[action$="/cart"], form[action*="/cart?"]');
    for (var i = 0; i < forms.length; i++) {
      var f = forms[i];
      if (f.querySelector('input[name="attributes[' + THUOC_TINH + ']"]')) continue;
      var inp = document.createElement('input');
      inp.type = 'hidden';
      inp.name = 'attributes[' + THUOC_TINH + ']';
      inp.value = luu.id;
      f.appendChild(inp);
    }
  }

  // 2b. Ghi thẳng vào giỏ qua AJAX khi giỏ có hàng mà chưa có thuộc tính
  var dangGhi = false;
  var daGhi = false;
  function ghiGio() {
    if (dangGhi || daGhi) return;
    dangGhi = true;
    fetch('/cart.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); }).then(function (gio) {
      if (!gio || !gio.item_count) { dangGhi = false; return; }
      if (gio.attributes && gio.attributes[THUOC_TINH] === luu.id) { daGhi = true; dangGhi = false; return; }
      var than = { attributes: {} };
      than.attributes[THUOC_TINH] = luu.id;
      return fetch('/cart/update.js', {
        method: 'POST', credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: JSON.stringify(than)
      }).then(function () { daGhi = true; dangGhi = false; });
    }).catch(function () { dangGhi = false; });
  }

  // Giỏ đổi (thêm/sửa qua AJAX của theme, Locksmith, app) → ghi lại. Bọc fetch và XHR, bỏ qua chính /cart/update.js của mình.
  (function canhGio() {
    var goc = window.fetch;
    if (goc) {
      window.fetch = function (u, o) {
        var url = typeof u === 'string' ? u : (u && u.url) || '';
        var p = goc.apply(this, arguments);
        if (/\/cart\/(add|change|clear)(\.js|\.json)?(\?|$)/.test(url)) p.then(function () { daGhi = false; setTimeout(ghiGio, 300); }, function () {});
        return p;
      };
    }
    var moGoc = XMLHttpRequest.prototype.open;
    XMLHttpRequest.prototype.open = function (m, url) {
      if (/\/cart\/(add|change|clear)(\.js|\.json)?(\?|$)/.test(String(url))) {
        this.addEventListener('loadend', function () { daGhi = false; setTimeout(ghiGio, 300); });
      }
      return moGoc.apply(this, arguments);
    };
    document.addEventListener('submit', function (e) {
      var f = e.target;
      if (f && f.getAttribute && /\/cart(\?|$)/.test(f.getAttribute('action') || '')) gaiForm();
    }, true);
  })();

  // 3. 17/09 15:50 (anh Thắng: "bít lỗ không biết A là ai") — ghi A lên HỒ SƠ B phía máy chủ ngay lúc B đăng ký nhận quà.
  //    localStorage chỉ sống trên máy đang dùng (đổi máy / Safari xoá sau 7 ngày là mất). Hộp thoại BLOY
  //    (.BLOY-popup__referral_email_action, nằm trong trang, không iframe) có ô email + nút "Đăng ký"; BLOY gọi
  //    /apps/bloy với body mã hoá nên không đọc được, theme tự đọc ô email lúc bấm nút, đợi BLOY báo
  //    "Đã ghi nhận lời mời" (referral_program_claim_tracked_title trong custom-bloy.js) rồi gửi
  //    Klaviyo client API (khoá công khai, giống đồng bộ ngày sinh 15/09): thuộc tính hồ sơ gioi_thieu_boi = id A.
  //    Flow E (Customer tags added gioi-thieu-khach) đọc thuộc tính này qua Klaviyo → ghi metafield
  //    gioi_thieu.nguoi_gioi_thieu lên khách B; Flow A/B/C đọc metafield đó khi đơn thiếu thuộc tính giỏ.
  var KLAVIYO = 'Rvg2GF';
  var KHOA_GUI = 'gt_ref_da_gui';
  function guiKlaviyo(email) {
    if (!email || !/^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(email)) return;
    var da = null; try { da = JSON.parse(localStorage.getItem(KHOA_GUI) || 'null'); } catch (e) {}
    if (da && da.email === email && da.id === luu.id) return;
    var than = { data: { type: 'profile', attributes: { email: email, properties: {
      gioi_thieu_boi: luu.id, gioi_thieu_luc: new Date().toISOString(), gioi_thieu_nguon: 'theme-popup'
    } } } };
    fetch('https://a.klaviyo.com/client/profiles?company_id=' + KLAVIYO, {
      method: 'POST', headers: { 'Content-Type': 'application/vnd.api+json', 'revision': '2024-10-15' },
      body: JSON.stringify(than), keepalive: true
    }).then(function (r) {
      if (r.status === 202) { try { localStorage.setItem(KHOA_GUI, JSON.stringify({ email: email, id: luu.id, ts: Date.now() })); } catch (e) {} }
    }).catch(function () {});
  }
  (function canhDangKy() {
    var emailCho = '';
    var dangDoi = null;
    document.addEventListener('click', function (e) {
      var nut = e.target && e.target.closest ? e.target.closest('.BLOY-popup__referral_email_action button, .BLOY-popup__referral_email_action .BLOY-button') : null;
      if (!nut) return;
      var o = nut.closest('.BLOY-popup__referral_email_action');
      var inp = o && o.querySelector('input.BLOY-popup__referral_email_input');
      var email = inp && inp.value ? String(inp.value).trim().toLowerCase() : '';
      if (!email) return;
      emailCho = email;
      if (dangDoi) clearInterval(dangDoi);
      var lan = 0;
      dangDoi = setInterval(function () {                 // đợi BLOY xác nhận, tối đa 20 giây
        lan++;
        var chu = '';
        var khoi = document.querySelectorAll('[class^="BLOY-popup"]');
        for (var i = 0; i < khoi.length; i++) chu += ' ' + (khoi[i].innerText || '');
        if (/Đã ghi nhận lời mời|You've been referred|đang được xét duyệt|being reviewed/i.test(chu)) {
          clearInterval(dangDoi); dangDoi = null; guiKlaviyo(emailCho);
        } else if (/không đủ điều kiện|not eligible|email hợp lệ|valid email/i.test(chu) || lan > 40) {
          clearInterval(dangDoi); dangDoi = null;
        }
      }, 500);
    }, true);
  })();

  function batDau() {
    gaiForm();
    ghiGio();
    new MutationObserver(gaiForm).observe(document.body, { childList: true, subtree: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', batDau);
  else batDau();
})();
